import { lazy } from 'react';
import { authRoles } from 'app/auth/authRoles';

const Notification = lazy(() => import('./Notification'));
const NotificationDetail = lazy(() => import('./NotificationDetail'));

const notificationRoutes = [
  {
    path: '/notification',
    component: Notification,
    auth: authRoles.admin,
    exact: true,
  },
  {
    path: '/notification/:id',
    component: NotificationDetail,
    auth: authRoles.admin,
    exact: true,
  },
];

export default notificationRoutes;
